module.exports = __webpack_public_path__ + "media/ResponsiveText.daaf48f4.mp4";